
<div class="container mt-48 text-center" *ngIf="isLoading">
  <app-spinnerdetial></app-spinnerdetial>
</div>
<div class="about mt-24 container mb-24 " *ngIf="!isLoading">
    <div class="container grid sm:grid-rows-2 md:grid-rows-2 xl:grid-rows-2">
        <div class="center header-title">
            <h1>{{dataDetail.name}}</h1>
            <p class="text-bold">
                It's not that difficult to learn everything
                <br/>
                just read step by step
            </p>
        </div>
    </div>
    <div class="banner-image">
        <iframe  src="{{dataDetail.linkVideo}}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        <div class="mt-4 text-center text-lg font-bold text-gray-500">
            <p>Just introduce myself</p>
        </div>
        <div class="about-me  text-center justify-center  p-2" style="width:100%;">
            <div class="serious pt-8 text-left p-5 w-full">
              <div class="w-full justify-start content" style="padding-left:150px; color: rgb(24, 22, 22); font-family: 'Poppins', sans-serif; padding-top:150px;" [innerHTML]="dataDetail.description"></div>
            </div>

        </div>
    </div>
</div>
